import React, { useEffect, useRef, useState } from "react";
import CloudComponent from "../CloudComponent";
import Cloud from "../Cloud";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";

const apiUrl = process.env.REACT_APP_API_URL;

const translations = {
  en: {
    selectLanguage: "Select Language:",
    questionTitle: "When did you lose the amount?",
    optionA: "Within 24 hours",
    optionB: "Between 24 - 48 hours",
    optionC: "Between 48 - 72 hours",
    optionD: "Above 72 hours",
    ok: "OK",
    errorSelect: "Please select an option before proceeding.",
    moveError:
      "Please answer the current question before proceeding to the next one.",
  },
  Hi: {
    selectLanguage: "भाषा चुनें:",
    questionTitle: "आपने राशि कब खोई?",
    optionA: "24 घंटों के भीतर",
    optionB: "24 - 48 घंटों के बीच",
    optionC: "48 - 72 घंटों के बीच",
    optionD: "72 घंटों से अधिक",
    ok: "ठीक है",
    errorSelect: "कृपया आगे बढ़ने से पहले एक विकल्प चुनें।",
    moveError: "कृपया अगले प्रश्न पर जाने से पहले वर्तमान प्रश्न का उत्तर दें।",
  },
  Kn: {
    selectLanguage: "ಭಾಷೆ ಆಯ್ಕೆ ಮಾಡಿ:",
    questionTitle: "ನೀವು ಯಾವಾಗ ಹಣವನ್ನು ಕಳೆದುಕೊಂಡಿದ್ದೀರಿ?",
    optionA: "24 ಗಂಟೆಗಳ ಒಳಗೆ",
    optionB: "24 - 48 ಗಂಟೆಗಳ ನಡುವೆ",
    optionC: "48 - 72 ಗಂಟೆಗಳ ನಡುವೆ",
    optionD: " 72 ಗಂಟೆಕ್ಕಿಂತ ಹೆಚ್ಚು",
    ok: "ಸರಿ",
    moveError:
      "ದಯವಿಟ್ಟು ಮುಂದಿನ ಪ್ರಶ್ನೆಗೆ ಹೋಗುವ ಮೊದಲು ಪ್ರಸ್ತುತ ಪ್ರಶ್ನೆಗೆ ಉತ್ತರ ನೀಡಿ.",
    errorSelect: "ದಯವಿಟ್ಟು ಮುಂದುವರೆಯುವ ಮೊದಲು ಒಂದು ಆಯ್ಕೆ ಮಾಡಿ.",
  },
  tulu: {
    selectLanguage: "ಭಾಷೆ ಆಯ್ಕೆ ಮಾಡಿ:",
    questionTitle: "ನೀವು ಯಾವಾಗ ಹಣವನ್ನು ಕಳೆದುಕೊಂಡಿದ್ದೀರಿ?",
    optionA: "24 ಗಂಟೆಗಳ ಒಳಗೆ ",
    optionB: "24 - 48 ಗಂಟೆಗಳ ನಡುವೆ ",
    optionC: "48 - 72 ಗಂಟೆಗಳ ನಡುವೆ",
    optionD: "72 ಗಂಟೆಗಿಂತ ಹೆಚ್ಚು.",
    ok: "ಸರಿ",
    errorSelect: "ದಯವಿಟ್ಟು ಮುಂದುವರೆಯುವ ಮೊದಲು ಒಂದು ಆಯ್ಕೆ ಮಾಡ್.",
  },
};

const audioMap = {
  en: "audio/English BOT Audios/time.mp3",
  Hi: "audio/Hindi BOT Audios/Hindi-Audio3.mp3",
  Kn: "audio/Kannada BOT Audios/Kannada-Audio3.m4a",
  tcy: "audio/cybervictim_tcy.mp3",
};

const Time = ({
  onNext,
  onTimeSelected,
  onQuestion,
  answer,
  apiKey,
  botToken,
  vist_id,
  app_ver,
  selectedLang,
}) => {
  const [timeId, setTimeId] = useState(null);
  const [time, setTime] = useState(null);
  const [showOkButton, setShowOkButton] = useState(true);
  const [error, setError] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false); // Audio play state
  const audioRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false); // Loading state for API call

  // Update audio source when the selected language changes.
  useEffect(() => {
    if (audioRef.current) {
      setIsPlaying(false);
      const audioSource = audioMap[selectedLang] || audioMap.en;
      audioRef.current.src = audioSource;
      audioRef.current.load(); // Reload the audio element to apply new source
    }
  }, [selectedLang]);

  useEffect(() => {
    const handler = () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        setIsPlaying(false);
      }
    };
    window.addEventListener("pauseAllAudio", handler);
    return () => window.removeEventListener("pauseAllAudio", handler);
  }, []);

  // Load stored time if any
  useEffect(() => {
    const storedData = localStorage.getItem("time");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setTimeId(parsed);
      setTime(parsed);
      onTimeSelected(parsed);
    }
  }, []);

  const handleOptionClick = async (option, e) => {
    e.preventDefault();
        setTimeId(option.id);
        setTime(option.value);
        // onTimeSelected(option.id);
    // try {
    //   const response = await fetch(`${apiUrl}/v1/ccrim_bot_register`, {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify({
    //       api_key: apiKey,
    //       visitor_token: vist_id,
    //       qtion_id: "66f6529450490",
    //       qtion_num: "1",
    //       qtion_option: option.id,
    //       option_val: option.value,
    //       lac_token: botToken,
    //       app_ver: app_ver,
    //       bot_lang_id:
    //         selectedLang === "en"
    //           ? "2"
    //           : selectedLang === "Hi"
    //           ? "3"
    //           : selectedLang === "Kn"
    //           ? "1"
    //           : "4",
    //     }),
    //   });
    //   const data = await response.json();
    //   if (data.resp.error_code === "0") {
    //     if (audioRef.current && isPlaying) {
    //       audioRef.current.pause();
    //       setIsPlaying(false);
    //     }
    //     setTimeId(option.id);
    //     setTime(option.id);
    //     onTimeSelected(option.id);
    //     localStorage.setItem("time", JSON.stringify(option.id));
    //     onNext(2);
    //     onQuestion(3);
    //     setShowOkButton(true);
    //     setError("");
    //   } else {
    //     setError(data.resp.message);
    //   }

    //   if (!response.ok) {
    //     throw new Error("Failed to push data to API");
    //   }
    // } catch (err) {
    //   console.error("Error sending data to API:", err);
    // }
  };

  const handleOkClick = async(e) => {
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
    if (time) {
      setIsSubmitting(true);
      try {
        const response = await fetch(`${apiUrl}/v1/ccrim_bot_register`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            api_key: apiKey,
            visitor_token: vist_id,
            qtion_id: "66f6529450490",
            qtion_num: "1",
            qtion_option: timeId,
            option_val: time,
            lac_token: botToken,
            app_ver: app_ver,
            bot_lang_id:
              selectedLang === "en"
                ? "2"
                : selectedLang === "Hi"
                ? "3"
                : selectedLang === "Kn"
                ? "1"
                : "4",
          }),
        });
        const data = await response.json();
        if (data.resp.error_code === "0") {
          if (audioRef.current && isPlaying) {
            audioRef.current.pause();
            setIsPlaying(false);
          }
          // setTimeId(option.id);
          // setTime(option.id);
          onTimeSelected(time);
          localStorage.setItem("time", JSON.stringify(time));
          onNext(2);
          onQuestion(3);
          setShowOkButton(true);
          setError("");
        } else {
          setError(data.resp.message);
        }
  
        if (!response.ok) {
          throw new Error("Failed to push data to API");
        }
      } catch (err) {
        console.error("Error sending data to API:", err);
      }finally {
        setIsSubmitting(false);
      }
    } else {
      setError("errorSelect");
      setShowOkButton(false);
    }
  };

  // Options array without hardcoded labels; labels will be rendered using translations
  const options = [
    { id: "A", value: "66ed1e0468ff6" },
    { id: "B", value: "66ed1e2bc8090" },
    { id: "C", value: "66ed1e4820de2" },
    { id: "D", value: "66ed1e62ab153" },
  ];

  const toggleAudio = (e) => {
    e.preventDefault();
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
  };

  return (
    <div className="question">
      <div>
        <div>
          <div style={{ display: "flex" }}>
            <h2>
              {translations[selectedLang].questionTitle}{" "}
              <span style={{ color: "red" }}>*</span>
            </h2>

            <button onClick={toggleAudio} className="audio-button">
              {isPlaying ? (
                <FaPause
                  color="White"
                  size={12}
                  style={{ marginBottom: "20px" }}
                />
              ) : (
                <FaPlay
                  color="White"
                  size={12}
                  style={{ marginBottom: "20px" }}
                />
              )}
            </button>
            <audio ref={audioRef} onEnded={handleAudioEnd}>
              <source src={audioMap[selectedLang]} type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
          </div>
          <div className="options-container">
            {options.map((option) => (
              <button
                key={option.id}
                className={`option-button ${
                  timeId === option.id ? "selected" : ""
                }`}
                onClick={(e) => handleOptionClick(option, e)}
              >
                <div className="answer-container">
                  <div
                    className="option"
                    style={{
                      backgroundColor: timeId === option.id ? "#000" : "#fff",
                      color: timeId === option.id ? "#fff" : "#000",
                    }}
                  >
                    {option.id}
                  </div>
                  <div className="option-label">
                    {translations[selectedLang][`option${option.id}`]}
                  </div>
                </div>
                {timeId === option.id && (
                  <span className="checkmark">&#10003;</span>
                )}
              </button>
            ))}
            <div>
              {showOkButton && (
                <>
                  <button
                    type="button"
                    className="ok-btn"
                    onClick={handleOkClick}
                    disabled={isSubmitting}
                    style={{ position: "relative", zIndex: "900" }}
                  >
                    {translations[selectedLang].ok}
                  </button>
                </>
              )}
              {error && (
                <div
                  className="error-message"
                  style={{ position: "relative", zIndex: "1000" }}
                >
                  {translations[selectedLang][error]}
                </div>
              )}
              {answer[1] && (
                <p className="alert-box">
                  {translations[selectedLang].moveError}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          position: "fixed",
          bottom: "0",
          left: "0",
          zIndex: "0",
        }}
      >
        <CloudComponent />
      </div>
      <div
        style={{
          position: "fixed",
          bottom: "0",
          right: "0",
          zIndex: "0",
        }}
      >
        <Cloud />
      </div>
    </div>
  );
};

export default Time;
